"use client";

import Image from "next/image";
import type { FormEvent } from "react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function HomeV2AppComingSoon() {
  const [submitted, setSubmitted] = useState(false);

  function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setSubmitted(true);
  }

  return (
    // Extra top padding so phones can sit ~10% above the blue card
    <section className="relative px-4 pt-16 pb-12 sm:px-6 lg:px-8 lg:pt-24 lg:pb-16">
      <div className="tt-gradient relative mx-auto min-h-[520px] max-w-[1400px] overflow-visible rounded-[30px] lg:min-h-[650px]">
        {/* Clip rings to the card only */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0 overflow-hidden rounded-[30px]"
        >
          <div className="-translate-y-1/2 absolute top-1/2 right-[-10%] hidden size-[907px] lg:block">
            <div className="absolute inset-[12%] rounded-full border-2 border-white/8 bg-white/5 opacity-60" />
            <div className="absolute inset-[26%] rounded-full border-2 border-white/8 bg-white/5 opacity-60" />
            <div className="absolute inset-[38%] rounded-full border-2 border-white/8 bg-white/5 opacity-60" />
          </div>
        </div>

        <div className="relative z-10 grid items-center gap-10 px-6 py-12 sm:px-10 lg:grid-cols-[minmax(0,696px)_1fr] lg:gap-4 lg:px-20 lg:py-16">
          <div className="relative z-10 text-white">
            <h2 className="font-bold text-[40px] leading-[1.2] max-sm:text-3xl">
              The TeleTradie App for iOS and Android is coming soon.
            </h2>

            <div aria-hidden className="h-6" />

            <p className="font-normal text-white/75 text-xl leading-[1.4]">
              Enter your details below to get notified.
            </p>

            <div aria-hidden className="h-10" />

            {submitted ? (
              <p className="font-medium text-lg text-tt-yellow">
                Thanks — we&apos;ll let you know when the app launches.
              </p>
            ) : (
              <form className="flex max-w-[616px] flex-col" onSubmit={onSubmit}>
                <div className="flex flex-col gap-3.5 sm:flex-row">
                  <Input
                    className="h-[54px] min-w-0 flex-1 rounded-lg border border-[#E9EDED] bg-white px-6 font-medium text-[#2C2C2C] text-base placeholder:text-[#9FB3C8] sm:min-w-[300px]"
                    name="name"
                    placeholder="Name"
                    required
                    type="text"
                  />
                  <Input
                    className="h-[54px] min-w-0 flex-1 rounded-lg border border-[#E9EDED] bg-white px-6 font-medium text-[#2C2C2C] text-base placeholder:text-[#9FB3C8] sm:min-w-[300px]"
                    name="email"
                    placeholder="Email Address"
                    required
                    type="email"
                  />
                </div>

                <div aria-hidden className="h-16" />

                <Button
                  className="h-[45px] w-fit min-w-[130px] rounded-full bg-tt-yellow px-6 font-semibold text-[#2C2C2C] text-lg leading-[1.4] hover:bg-tt-yellow/90"
                  type="submit"
                >
                  Let me know
                </Button>
              </form>
            )}
          </div>

          {/* Mobile: inline. Desktop: oversized, top overhangs ~10% above blue */}
          <div className="relative mx-auto aspect-[898/758] w-full max-w-md lg:mx-0 lg:aspect-auto lg:h-[450px] lg:max-w-none">
            <div className="lg:-top-[5%] absolute inset-0 lg:right-[-4%] lg:bottom-auto lg:left-0 lg:h-[110%] lg:w-[115%]">
              <Image
                alt="TeleTradie mobile app previews"
                className="scale-[1.32] object-contain object-top drop-shadow-2xl lg:scale-150 lg:object-right-top"
                fill
                sizes="(max-width: 1024px) 90vw, 55vw"
                src="/images/homev2/feature_mobile.png"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
